import SETTINGS from '../constants/settings';

export const mergedSettings = (data, orgSettings) => {
  let sets = JSON.parse(JSON.stringify(SETTINGS));
  if (!data || data.length === 0) {
    return sets.map(sett => {
      sett.scrDefault = sett.enabled;
      if (orgSettings && orgSettings[sett.slug]){
        sett.orgDefault = orgSettings[sett.slug];
      }

      return sett;
    });
  } else {
    return sets.map(sett => {
      let existing = data[sett.slug];
      sett.scrDefault = sett.enabled;
      if (orgSettings && orgSettings.hasOwnProperty(sett.slug)){
        sett.orgDefault = orgSettings[sett.slug];
      }
      if (existing !== undefined) {
        sett.enabled = existing;
      }
      return sett;
    });
  }
}
